import ArrestBook from "../InmateDetails/ArrestBook";
import { PERSON } from "../InmateDetails/Personal";

const ArrestInformationDetails = ({ arrestbookFormRef,startingPoint }) => {
  return (
    <>
      <ArrestBook
        person={PERSON.BOOKINGS}
        arrestbookFormRef={arrestbookFormRef}
        startingPoint={startingPoint}
      />
    </>
  );
};
export default ArrestInformationDetails;
